import React from 'react';
import { connect } from "react-redux";
import {Grid} from "semantic-ui-react";
import Header from "../../../common/components/Header";
import BillingOrganizationsTable from "./BillingOrganizationsTable";
import {InlineLoading} from "../../../common/partials/Loading";
import {fetchBillingOrganizationsTableData, unmountBillingOrg} from "../actions/BillingOrganizationsActions";
import Breadcrumb from '../../../common/partials/Breadcrumb';
import { setBreadCrumb } from '../../../veritas/breadcrumb/BreadcrumbActions';
import Sidebar from "../../../common/components/Sidebar";
import BillingSidebarButtons from "../../shared/BillingSidebarButtons";

export class BillingOrganizationsListPage extends React.Component {

    componentDidMount() {
        this.props.getBillingOrganizationsData();
        document.title = `Billing - Organizations`;

        this.props.setBreadCrumb({
            parent: { url: '/billing', text: 'Billing   ' },
            list: { url: '/billing/organizations', text: 'Organizations' },
            service: { url: '', text: '' },
            source: { url: '', text: '' }
        })
    }

    componentWillUnmount() {
        this.props.unmountBilling();
    }

    render() {
        return (
            <div className="billing">
                <Header />
                <Grid relaxed={true}>
                    <Grid.Column width={3}>
                        <Sidebar>
                            <BillingSidebarButtons />
                        </Sidebar>
                    </Grid.Column>
                    <Grid.Column width={13}>
                        <Breadcrumb />
                        {this.props.billing_organizations
                            ? (<BillingOrganizationsTable
                                BillingOrganizationsData={this.props.filtered_billing_organizations} />)
                            : (<InlineLoading />) }
                    </Grid.Column>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    billing_organizations: state.billing.organizations.billing_organizations,
    filtered_billing_organizations: state.billing.organizations.filtered_billing_organizations,
});

const mapDispatchToProps = dispatch => ({
    getBillingOrganizationsData: () => {dispatch(fetchBillingOrganizationsTableData())},
    unmountBilling: () => {dispatch(unmountBillingOrg())},
    setBreadCrumb: (crumb) => { dispatch(setBreadCrumb(crumb)) },
});


export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(BillingOrganizationsListPage)
